export class SearchDataLog {
    practice: any;
    provider: any;
    patient: any;
    plan_check_in: any;
    plan_check_in_to: any;
    timezone: any;
}
